import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import ENV from "config/Env";
import ApiInstance from "util/Api";

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ALLOWED_EXTENSION = ".xlsx";

const uploadFile = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await ApiInstance.post("/web/upload", formData, ENV.recallsBaseUrl);
  return response;
};

export const useRecallsUpload = () => {
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const mutation = useMutation({
    mutationFn: uploadFile,
    onSuccess: () => {
      setUploadError(null);
      setUploadSuccess(true);
    },
    onError: error => {
      console.error(error.message);
      setUploadError(error.message);
      setUploadSuccess(false);
    }
  });

  const upload = (file: File | null) => {
    setUploadError(null);
    setUploadSuccess(false);

    if (!file) {
      setUploadError("No file selected.");
      return;
    }

    if (!file.name.toLowerCase().endsWith(ALLOWED_EXTENSION)) {
      setUploadError("Invalid file type.");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setUploadError("File size exceeds the limit.");
      return;
    }

    mutation.mutate(file);
  };

  return {
    upload,
    isLoading: mutation.isPending,
    isError: uploadError,
    isSuccess: uploadSuccess
  };
};
